export const ATTENDANCE_MOBILE_HEADER_NAV_BUTTON_CLASS =
  "w-9 h-9 flex items-center justify-center bg-white rounded-full shadow-sm text-gray-600 border border-gray-100/50 active:scale-95";

export const ATTENDANCE_MOBILE_HEADER_SEARCH_INPUT_CLASS =
  "w-full pl-8 pr-3 h-9 bg-white rounded-xl text-xs font-bold border border-gray-100 shadow-sm focus:outline-none focus:ring-1 focus:ring-gray-200 transition-all";

export const ATTENDANCE_MOBILE_SORT_BUTTON_BASE_CLASS =
  "w-9 h-9 flex items-center justify-center bg-white rounded-xl border border-gray-100 shadow-sm transition-all active:scale-95";

export const ATTENDANCE_MOBILE_DAILY_STATUS_BUTTON_BASE_CLASS =
  "w-9 h-9 rounded-xl flex items-center justify-center transition-all";

export const ATTENDANCE_MOBILE_BULK_STATUS_BUTTON_BASE_CLASS =
  "bg-white/10 hover:bg-white text-white rounded-2xl font-black transition active:scale-95 shadow-sm flex-shrink-0";

export const ATTENDANCE_DETAIL_MODAL_OVERLAY_CLASS =
  "fixed inset-0 bg-black/60 flex items-center justify-center z-[1000] p-4 transform-gpu";

export const ATTENDANCE_DETAIL_MODAL_CONTAINER_CLASS =
  "bg-white rounded-[2.5rem] w-full max-w-sm shadow-2xl relative overflow-hidden border border-white/50 animate-scale-up max-h-[85vh] flex flex-col transform-gpu";

export const ATTENDANCE_DETAIL_MODAL_CLOSE_BUTTON_CLASS =
  "text-gray-400 hover:text-gray-600 transition bg-gray-100 hover:bg-gray-200 p-2 rounded-full";

export const ATTENDANCE_DETAIL_MODAL_CONTENT_CLASS =
  "w-full h-full overflow-y-auto custom-scrollbar p-0 flex flex-col";

export const ATTENDANCE_DETAIL_MODAL_INNER_CLASS =
  "px-8 pb-10 pt-12 relative z-10 w-full flex flex-col";

export const ATTENDANCE_DETAIL_SECTION_TITLE_CLASS =
  "text-xl font-bold text-gray-900 mb-4 px-1";

export const ATTENDANCE_DETAIL_INFO_ROW_CLASS =
  "flex justify-between items-center py-4 px-1 border-b border-gray-50";

export const ATTENDANCE_DETAIL_INFO_LABEL_CLASS =
  "text-gray-500 font-medium text-base";

export const ATTENDANCE_DAILY_CARD_GRID_CLASS =
  "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 pb-24 relative z-0";

export const ATTENDANCE_DAILY_CARD_BASE_CLASS =
  "relative rounded-[2rem] overflow-hidden transition-all duration-300 cursor-pointer group border";

export const ATTENDANCE_DAILY_CARD_SELECTED_CLASS = "z-10 scale-[1.02]";

export const ATTENDANCE_DAILY_CARD_SELECTED_CHECK_CLASS =
  "absolute top-3 right-3 w-5 h-5 rounded-full border flex items-center justify-center transition-all duration-300 z-20 scale-110";

export const ATTENDANCE_DAILY_CARD_UNSELECTED_CHECK_CLASS =
  "absolute top-3 right-3 w-5 h-5 rounded-full border flex items-center justify-center transition-all duration-300 z-20 border-gray-200 opacity-0 group-hover:opacity-100 bg-white";

export const ATTENDANCE_DAILY_CARD_BODY_CLASS = "p-4 flex flex-col items-center text-center";

export const ATTENDANCE_DAILY_CARD_AFFILIATION_BADGE_CLASS =
  "text-[10px] font-bold px-2 py-0.5 rounded-lg border bg-white/50 text-gray-500 border-gray-200/50";

export const ATTENDANCE_DAILY_CARD_STATUS_GROUP_CLASS =
  "w-full bg-white/50 backdrop-blur-sm p-0.5 rounded-full flex relative items-center justify-between border border-gray-100/50 shadow-inner";

export const ATTENDANCE_DAILY_CARD_STATUS_BUTTON_BASE_CLASS =
  "flex-1 h-8 rounded-full flex items-center justify-center gap-1 text-[11px] font-bold transition-all duration-300";

export const ATTENDANCE_DAILY_CARD_STATUS_DOT_BASE_CLASS = "w-1.5 h-1.5 rounded-full";

export function getAttendanceBulkThemeBgClass(hoverState, themeBg) {
  if (hoverState === "present") return "bg-emerald-600";
  if (hoverState === "late") return "bg-yellow-500";
  if (hoverState === "absent") return "bg-rose-500";
  return themeBg;
}

export function getAttendanceMobileSortButtonClass(sortOrder, primaryTextClass) {
  return `${ATTENDANCE_MOBILE_SORT_BUTTON_BASE_CLASS} ${sortOrder === "desc" ? primaryTextClass : "text-gray-400"
    }`;
}

export function getAttendanceMobileDailyStatusButtonClass(currentStatus, targetStatus) {
  if (targetStatus === "present") {
    return `${ATTENDANCE_MOBILE_DAILY_STATUS_BUTTON_BASE_CLASS} ${currentStatus === "present"
      ? "bg-emerald-500 text-white shadow-sm scale-105"
      : "bg-gray-50 text-gray-300 hover:bg-emerald-50 hover:text-emerald-500"
      }`;
  }
  if (targetStatus === "late") {
    return `${ATTENDANCE_MOBILE_DAILY_STATUS_BUTTON_BASE_CLASS} ${currentStatus === "late"
      ? "bg-amber-400 text-white shadow-sm scale-105"
      : "bg-gray-50 text-gray-300 hover:bg-amber-50 hover:text-amber-500"
      }`;
  }
  return `${ATTENDANCE_MOBILE_DAILY_STATUS_BUTTON_BASE_CLASS} ${currentStatus === "absent"
    ? "bg-rose-500 text-white shadow-sm scale-105"
    : "bg-gray-50 text-gray-300 hover:bg-rose-50 hover:text-rose-500"
    }`;
}

export function getAttendanceMobileBulkStatusButtonClass(status, isMobile) {
  let statusClass = "bg-emerald-500 text-white shadow-[0_2px_10px_rgba(16,185,129,0.2)] border-emerald-400/30";
  if (status === "late") statusClass = "bg-amber-400 text-white shadow-[0_2px_10px_rgba(251,191,36,0.2)] border-amber-300/30";
  if (status === "absent") statusClass = "bg-rose-500 text-white shadow-[0_2px_10px_rgba(244,63,94,0.2)] border-rose-400/30";

  return `rounded-2xl font-black transition active:scale-95 border flex items-center justify-center gap-1.5 ${statusClass} ${isMobile ? "px-2.5 py-2 text-[10px]" : "px-4 py-2.5 text-xs"
    }`;
}

export function getAttendanceDailyCardClass({ status, isSelected, brand }) {
  let hoverThemeClass = "hover:shadow-xl hover:-translate-y-1 border-gray-100 shadow-sm";
  let bgClass = "bg-white";
  if (status === "present") {
    hoverThemeClass = "hover:shadow-xl hover:-translate-y-1 border-[#E3F9E5] shadow-sm";
    bgClass = "bg-[#E3F9E5]";
  }
  if (status === "late") {
    hoverThemeClass = "hover:shadow-xl hover:-translate-y-1 border-[#FFF8E1] shadow-sm";
    bgClass = "bg-[#FFF8E1]";
  }
  if (status === "absent") {
    hoverThemeClass = "hover:shadow-xl hover:-translate-y-1 border-[#FFEBEB] shadow-sm";
    bgClass = "bg-[#FFEBEB]";
  }
  if (isSelected) {
    return `${ATTENDANCE_DAILY_CARD_BASE_CLASS} ring-4 ${brand.primaryShadowSoftClass} ${brand.primaryBorderSolidClass} ${ATTENDANCE_DAILY_CARD_SELECTED_CLASS} ${bgClass}`;
  }
  return `${ATTENDANCE_DAILY_CARD_BASE_CLASS} ${hoverThemeClass} ${bgClass}`;
}

export function getAttendanceDailyCardCheckClass(isSelected, brand) {
  if (isSelected) {
    return `${ATTENDANCE_DAILY_CARD_SELECTED_CHECK_CLASS} ${brand.primaryBgClass} ${brand.primaryBorderSolidClass}`;
  }
  return ATTENDANCE_DAILY_CARD_UNSELECTED_CHECK_CLASS;
}

export function getAttendanceDailyCardStatusButtonClass(currentStatus, targetStatus) {
  if (targetStatus === "present") {
    return `${ATTENDANCE_DAILY_CARD_STATUS_BUTTON_BASE_CLASS} !w-7 !h-7 !rounded-xl ${currentStatus === "present" ? "bg-white text-emerald-600 shadow-sm ring-1 ring-black/5" : "text-gray-400 hover:text-gray-600"
      }`;
  }
  if (targetStatus === "late") {
    return `${ATTENDANCE_DAILY_CARD_STATUS_BUTTON_BASE_CLASS} !w-7 !h-7 !rounded-xl ${currentStatus === "late" ? "bg-white text-amber-500 shadow-sm ring-1 ring-black/5" : "text-gray-400 hover:text-gray-600"
      }`;
  }
  return `${ATTENDANCE_DAILY_CARD_STATUS_BUTTON_BASE_CLASS} !w-7 !h-7 !rounded-xl ${currentStatus === "absent" ? "bg-white text-rose-500 shadow-sm ring-1 ring-black/5" : "text-gray-400 hover:text-gray-600"
    }`;
}

export function getAttendanceDailyCardStatusDotClass(currentStatus, targetStatus) {
  if (targetStatus === "present") {
    return `${ATTENDANCE_DAILY_CARD_STATUS_DOT_BASE_CLASS} ${currentStatus === "present" ? "bg-emerald-500" : "bg-gray-300"}`;
  }
  if (targetStatus === "late") {
    return `${ATTENDANCE_DAILY_CARD_STATUS_DOT_BASE_CLASS} ${currentStatus === "late" ? "bg-amber-400" : "bg-gray-300"}`;
  }
  return `${ATTENDANCE_DAILY_CARD_STATUS_DOT_BASE_CLASS} ${currentStatus === "absent" ? "bg-rose-500" : "bg-gray-300"}`;
}
